/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react'
import { Col, FormGroup, Label } from 'reactstrap'
import Resx from '@/components/Resx'
import { ValidationContext } from '@/components/validation/validationContext'
import PropTypes from 'prop-types'
import { Validator } from '@/components/validation'
import AssigneeSelector from '@/components/AssigneeSelector/AssigneeSelector'
import { DatePicker } from '@/components/DatePicker'
import { NumericInput } from '@/components/inputs'
import { isInteger } from '@/utils/numberUtilities'

const sanitizeInteger = (value) => isInteger(value) ? value : null

function MergedCompaniesInputs (props) {
  const { value, onChange } = props
  const { makerUser, makerUserId, dueDate, minimumInstitutions } = value
  const validationContext = useContext(ValidationContext)

  // Clear dependant fields
  useEffect(() => {
    validationContext.resetErrors(['companyId', 'reportGroupSubmissionId', 'bankId'])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return <FormGroup>
    <FormGroup row>
      <Label sm='2' className='label'><Resx name='Tickets.Assignee' /></Label>
      <Col sm='4'>
        <Validator name='makerUserId' value={makerUserId} required>
          <AssigneeSelector
            value={makerUser}
            onChange={user => onChange({ ...value, makerUserId: user ? user.id : null, makerUser: user })} />
        </Validator>
      </Col>
      <Label sm='2' className='label'><Resx name='Tickets.DueDate' /></Label>
      <Col sm='4'>
        <Validator name='dueDate' value={dueDate}>
          <DatePicker
            value={dueDate}
            onChange={date => onChange({ ...value, dueDate: date })} />
        </Validator>
      </Col>
    </FormGroup>
    <FormGroup row>
      <Label sm='2' className='label'><Resx name='Tickets.InstitutionMinimum' /></Label>
      <Col sm='4'>
        <Validator name='minimumInstitutions' value={minimumInstitutions}>
          <NumericInput integerOnly min={0} value={minimumInstitutions}
            onChange={minimum => onChange({
              ...value,
              minimumInstitutions: sanitizeInteger(minimum)
            })} />
        </Validator>
      </Col>
    </FormGroup>
  </FormGroup>
}

export { MergedCompaniesInputs }

MergedCompaniesInputs.propTypes = {
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/dialogs/ticketTypes/mergedCompanies.js